import { render, staticRenderFns } from "./MasterDataMajorList.vue?vue&type=template&id=2c97c05e&"
import script from "./MasterDataMajorList.vue?vue&type=script&lang=js&"
export * from "./MasterDataMajorList.vue?vue&type=script&lang=js&"
import style0 from "./MasterDataMajorList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports